import React from 'react'

import PropTypes from 'prop-types'

import { useT } from '@galo-monitor/i18n'
import { eyeClosed } from '@galo-monitor/icons'
import { colors } from '@galo-monitor/styles'
import Icon from '@galo-monitor/web-components/Icon'

import IconButton from '../IconButton'

const EyeClosedIconButton = ({ iconColor, ...props }) => {
  const t = useT()
  return (
    <IconButton tooltip={ t('show password') } { ...props }>
      <Icon icon={ eyeClosed } color={ iconColor } />
    </IconButton>
  )
}

EyeClosedIconButton.propTypes = {
  iconColor: PropTypes.string
}

EyeClosedIconButton.defaultProps = {
  iconColor: colors.mutedText
}

export default EyeClosedIconButton
